import React from 'react';
import styled from 'styled-components';
import Section, { SectionTitle } from '../../common/Section.js';
import Card, { CardImage, CardBody, CardFooter } from '../../common/Card.js';
import Button from '../../common/Button.js';
import { Link } from 'react-router-dom';
import { FaBed, FaBath, FaRuler } from 'react-icons/fa';

const ListingsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ListingCard = styled(Card)`
  .features {
    display: flex;
    gap: 1.5rem;
    margin-top: 1rem;
    
    .feature {
      display: flex;
      align-items: center;
      
      svg {
        color: var(--secondary);
        margin-right: 0.5rem;
      }
    }
  }
`;

const Price = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--primary);
`;

const ViewAllButton = styled.div`
  text-align: center;
`;

const FeaturedListings = () => {
  // Mock data for featured listings
  const listings = [
    {
      id: 1,
      title: "Modern Family Home",
      address: "Homestead, High Point, NC",
      price: "$424,000",
      bedrooms: 4,
      bathrooms: 3,
      sqft: 2172,
      image: "/images/home1.png",
      tag: "SOLD"
    },
    {
      id: 2,
      title: "Luxury Townhouse",
      address: "Whitsett, NC",
      price: "$1,189,000",
      bedrooms: 4,
      bathrooms: 3.5,
      sqft: 5247,
      image: "/images/home2.png",
      tag: "SOLD"
    },
    {
      id: 3,
      title: "Transitional Home",
      address: "Wiley Park, Greensboro, NC",
      price: "$480,700",
      bedrooms: 4,
      bathrooms: 3,
      sqft: 2542,
      image: "/images/home3.png",
      tag: "SOLD"
    }
  ];
  
  return (
    <Section>
      <div className="container">
        <SectionTitle>
          <h2>Featured Listings</h2>
          <p>Explore our latest homes available for purchase</p>
        </SectionTitle>
        
        <ListingsGrid>
          {listings.map(listing => (
            <ListingCard key={listing.id}>
              <CardImage height="250px">
                <img src={listing.image} alt={listing.title} />
                <div className="card-tag">{listing.tag}</div>
              </CardImage>
              <CardBody>
                <h3>{listing.title}</h3>
                <p>{listing.address}</p>
                <div className="features">
                  <div className="feature">
                    <FaBed />
                    <span>{listing.bedrooms} Beds</span>
                  </div>
                  <div className="feature">
                    <FaBath />
                    <span>{listing.bathrooms} Baths</span>
                  </div>
                  <div className="feature">
                    <FaRuler />
                    <span>{listing.sqft} sqft</span>
                  </div>
                </div>
              </CardBody>
              <CardFooter>
                <Price>{listing.price}</Price>
                <Button as={Link} to={`/for-sale/${listing.id}`} variant="outline" size="small">
                  View Details
                </Button>
              </CardFooter>
            </ListingCard>
          ))}
        </ListingsGrid>
        
        <ViewAllButton>
          <Button as={Link} to="/for-sale" variant="secondary">
            View All Listings
          </Button>
        </ViewAllButton>
      </div>
    </Section>
  );
};

export default FeaturedListings;